import {
  Button,
  CircularProgress,
  FormControl,
  TextField,
} from '@mui/material';
import React, { lazy, Suspense, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import ScreenLoader from '../../../components/Common/ScreenLoader';
import { SharedStyledComponents } from '../OnboardingPage';
import { useOnboarding } from '../../../contexts/OnboardingContext';
import { logger } from '../../../utils/logger';

const DynamicComponentRenderer = () => {
  const { stepsInfo } = useOnboarding();

  if (stepsInfo.component) {
    const LazyComponent = lazy(() => import(`./${stepsInfo.component}`));

    return (
      <Suspense fallback={<ScreenLoader />}>
        {LazyComponent ? <LazyComponent /> : <div>Step not found</div>}
      </Suspense>
    );
  }
};

const BasicDetails = () => {
  const { stepsInfo, handleSteps, setIsBackClick, backButtonRef, editingMode } =
    useOnboarding();

  const currStepNo = stepsInfo?.order;
  const totalStepNo = stepsInfo?.totalSteps;
  const isLastStep = totalStepNo === currStepNo;
  const { FormWrapper, ContentWrapper, BackButton, ButtonWrapper } =
    SharedStyledComponents;
  logger.log('currStepNo', currStepNo);

  useEffect(() => {
    backButtonRef.current = () => {
      const newStepNo = stepsInfo.order - 1;
      handleSteps(newStepNo);
      setIsBackClick(true);
    };
  }, [stepsInfo, handleSteps]);

  return (
    <FormWrapper>
      {currStepNo !== 1 && !editingMode && (
        <BackButton
          onClick={() => backButtonRef.current()}
          className="lyt-bck-btn"
        >
          <FontAwesomeIcon icon={faAngleLeft} />
        </BackButton>
      )}
      <ContentWrapper>
        {!isLastStep && (
          <div className="progress-wrapper">
            <CircularProgress
              variant="determinate"
              value={Math.abs((currStepNo - 1) / totalStepNo) * 100}
              size={43}
              thickness={3}
              color="primary"
              progressColor="green"
              backgroundColor="#ccc"
            />
            <div className="pg">{totalStepNo - currStepNo}</div>
          </div>
        )}

        <DynamicComponentRenderer />
      </ContentWrapper>
    </FormWrapper>
  );
};

export const CommonStyles = css`
  h3 {
    font-size: 24px;
    color: #253858;
    margin-bottom: 12px;
  }

  h4 {
    color: #666;
    font-size: 16px;
    margin-bottom: 16px;
  }

  p {
    color: #666;
    font-size: 16px;
    margin: 0;
  }

  button {
    background: #4c6fff;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 16px 32px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
    transition: background 0.2s;

    &:hover {
      background: #3955cc;
    }
  }
`;

export default BasicDetails;
